export default __webpack_public_path__ + "static/media/plus-grey.384e48c4.svg";